import * as _ from "lodash";
import * as React from "react";
import {AppConstants, FoodGroup, MealSlots} from "../../../utils/AppConstants";
import IFoodGroup from "../../../models/IFoodGroup";
import AppUtils from "../../../utils/AppUtils";
import * as moment from "moment";
import IMealSlot from "../../../models/IMealSlot";
import IMealItem, {IMealComponent} from "../../../models/IMealItem";
import LocalStorageUtils from "../../../utils/LocalStorageUtils";

export interface MealItemProps {
    mealId: string;
    index: number;
}
export class MealItem extends React.Component<MealItemProps> {
    constructor(props: MealItemProps) {
        super(props);
    }
    render() {
        let mealItem = LocalStorageUtils.getMealFromMealId(this.props.mealId);
        let index = this.props.index;
        return <div className={"meal-option-item-container prescription-description"} key={mealItem && mealItem.mealId}>
            <div>
                <div className={"meal-number-container"}>
                    <span className={"meal-number"}>{index + 1}</span>
                </div>
                <div className={"meal-items-container"}>
                    {
                        _.map( mealItem && mealItem.components, (component: IMealComponent) => {
                            return <span className={"meal-component"} key={`${component.displayName}-${component.quantity}-${component.unit}-${component.dishId}`}>
                                        <span className={"brandon-bold"}>
                                            <span className={"unit-icon"}><img src={AppUtils.getDishIcon(component.unit)} /></span>
                                            <span className={"dish-unit-details"}>{component.quantity} {component.unit}</span>
                                        </span>
                                        <span className={"dish-name"}>{component.displayName}</span>
                                    </span>
                        })
                    }
                </div>
            </div>
        </div>
    }
}

export interface DietPlanPDFProps {
    id: string;
    mealSlots: IMealSlot[];
    mealItems: any;
}

class DietPlanPDFTemplate extends React.Component<DietPlanPDFProps> {
    getMealItem = () => {
        let mealSlot = this.props.id.replace("meal-slot-", "");
        let requiredSlotObject = this.props.mealSlots.filter(item => item.mealSlot === mealSlot);
        return requiredSlotObject.length > 0 ? requiredSlotObject[0] : null;
    }
    render() {
        let mealItem = this.getMealItem();
        return (
            <div id={`meal-slot-${mealItem.mealSlot}`} className="meal-slot prescription-grid-row external-row">
                <div className="prescription-card-content">
                    {/*<div className={"meal-slot-container"}>
                        {
                            !_.isEmpty(mealItem.recommendedTimeOfDay) &&
                            <div className={"meal-time brandon-bold"}>{moment(mealItem.recommendedTimeOfDay, "HH:mm").format("hh:mm A")}</div>
                        }
                        <div className={"brandon-bold meal-slot-header"}>
                            <img src={AppUtils.getSlotIcon(mealItem.mealSlot)} />
                            {MealSlots[mealItem.mealSlot].toUpperCase()}
                        </div>
                        {
                            !_.isEmpty(mealItem.details.calorieBreakup) &&
                            <div>
                                {
                                    _.map(mealItem.details.calorieBreakup, (themes: IFoodGroup[], index: number) => {
                                        return <div className={"theme-row-container"} key={`themes-${index}`}>
                                            <div className={"theme-label"}>{`Theme ${index + 1}`}</div>
                                            <div className={"theme-value-container"}>
                                                {
                                                    _.map(themes, (theme: IFoodGroup, index: number) => {
                                                        return <span className={"theme-value brandon-bold"} key={`${theme.contribution}-${index}`}>
                                                                                                    <span className={"brandon-bold"}>{theme.contribution}%</span>
                                                                                                    <span className={"theme-value-label"}>{FoodGroup[AppUtils.getFoodGroupsIdFromList(theme.foodgroups)]}</span>
                                                                                                </span>
                                                    })
                                                }
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                        }
                    </div>*/}
                    {
                        !_.isEmpty(mealItem.details.mealIds) &&
                        <div id={`meal-slot-${mealItem.mealSlot}-subsection`} className={"meal-options-container"}>
                            {
                                _.map(this.props.mealItems, (mealId: any, index: number) => {
                                    if (!mealId.hasOwnProperty("mealSlot")) {
                                        return <MealItem mealId={mealId.item} index={mealId.index}/>
                                    } else {
                                        return <div className={"meal-slot-container"}>
                                            {
                                                !_.isEmpty(mealItem.recommendedTimeOfDay) &&
                                                <div className={"meal-time brandon-bold"}>{moment(mealItem.recommendedTimeOfDay, "HH:mm").format("hh:mm A")}</div>
                                            }
                                            <div className={"brandon-bold meal-slot-header"}>
                                                <img src={AppUtils.getSlotIcon(mealItem.mealSlot)} />
                                                {MealSlots[mealItem.mealSlot].toUpperCase()}
                                            </div>
                                            {
                                                !_.isEmpty(mealItem.details.calorieBreakup) &&
                                                <div>
                                                    {
                                                        _.map(mealItem.details.calorieBreakup, (themes: IFoodGroup[], index: number) => {
                                                            return <div className={"theme-row-container"} key={`themes-${index}`}>
                                                                <div className={"theme-label"}>{`Theme ${index + 1}`}</div>
                                                                <div className={"theme-value-container"}>
                                                                    {
                                                                        _.map(themes, (theme: IFoodGroup, index: number) => {
                                                                            return <span className={"theme-value brandon-bold"} key={`${theme.contribution}-${index}`}>
                                                                                                    <span className={"brandon-bold"}>{theme.contribution}%</span>
                                                                                                    <span className={"theme-value-label"}>{FoodGroup[AppUtils.getFoodGroupsIdFromList(theme.foodgroups)]}</span>
                                                                                                </span>
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                })
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default DietPlanPDFTemplate;